import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { CORE_CONFIGURATION } from '../../core/configuration';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class NetworkGuaranteeApiService {
  constructor(private http: BaseApiService, @Inject(CORE_CONFIGURATION) private config) {
  }

  /**
   * networkguarantee api get claims type array data
   * @param msisdn current msisdn
   */
  claims(msisdn: string): Observable<any> {
    return of({
      sections: [{
        id: '23',
        title: 'Impossibilità di connessione',
        imageUrl: 'https://mybusiness.vodafone.it/media/images/networkguarantee/59fe7555ba6760a8cf46d7f50f08e95c.png',
      }, {
        id: '25',
        title: 'Connessione internet lenta',
        imageUrl: 'https://mybusiness.vodafone.it/media/images/networkguarantee/ic_vodafone-business_connessione-dati.png'
      }],
      status: {
        sendEnabled: true,
        disabledMessage: ''
      }
    });
  }

  /**
   * networkguarantee api get claim data
   * @param msisdn current msisdn
   */
  claim(msisdn: string, idClaim: string): Observable<any> {
    return of({
      title: 'Impossibilità di connessione',
      paragraphs: ['Prima di inviare la segnalazione:<br><ul><li>verifica di non aver terminato i GB inclusi nella tua offerta nella sezione Contatori</li><li>verifica di aver configurato correttamente l’APN (mobile.vodafone.it o se possiedi un iphone iphone.vodafone.it) nelle impostazioni del tuo Smartphone</li></ul>'],
      claim_type: 'no_conn'
    });
  }

  /**
   * networkguarantee api get claim data
   * @param msisdn current msisdn
   */
  sendClaim(msisdn: string, idClaim: string, body: any): Observable<any> {
    return of({
      outcome: 'OK',
      typ: {
        text: 'L’iniziativa è riservata ai cllienti con Smartphone e con un’offerta 4G attiva.',
        img_url: 'https://mybusiness.vodafone.it/media/images/networkguarantee/ceb716354f0a7470857616ec7f21d7af.png'
      }
    });
  }

  /**
   * extremeTrust api get c2c data
   * @param msisdn current msisdn
   */
  extremeTrust(msisdn) {
    return of([{
      type: 'cmb',
      label: 'Ti chiamiamo noi',
      params: {
        channel: 'cb_voce',
        msisdn: 'GC4latv3/DQP9wAlLrQ/nw==',
        custCode: 'Fgm1nT/7MxyD8Gn68NuUQw=='
      }
    }]);
  }
}
